<template>
  <div
    class="right_body action_body"
    v-loading="isLoading"
    :element-loading-background="loadingBg"
    :element-loading-text="loadingTxt"
  >
    <span class="btn right_sub_btn del_btn" style="margin-right:120px" @click.stop="subCheck">检查数据</span>
    <span class="btn right_sub_btn save_btn" @click.stop="subSave">提交数据</span>
    <div class="active_rumb">
      <span class="txt">销售订单发货</span>
    </div>

    <div class="coll header_box">
      <h2 class="title">
        <span>抬头信息</span>
      </h2>
      <v-head
        :fromData="fromData"
        :noFromData="noFromData"
        :customerList="this.$store.state.cache.customerList"
        :factoryList="this.$store.state.cache.factoryList"
        :companyList="this.$store.state.cache.companyList"
      ></v-head>
    </div>
    <div class="coll list_content">
      <h2 class="title"> 
        <span>数据明细</span>
      </h2>
      <v-list :fromData="fromData" :noFromData="noFromData" ref="vList"></v-list>
    </div>
    <div class="coll list_content">
      <h2 class="title">
        <span>行项目备注</span>
      </h2>
      <el-input type="textarea" :rows="2" placeholder="请输入内容" v-model="textarea"></el-input>
    </div>
  </div>
</template>

<script>
import { customerApi} from "api/base.js";
import {sale,sendOrder} from "api/business.js";
import { company } from "api/system.js";

import vHead from "./components/orderSend/head.vue";
import vList from "./components/orderSend/list.vue";

import { mapState, mapActions } from "vuex";
export default {
  props: ["data1", "data2"],
  components: {
    vHead,
    vList
  },
  data() {
    return {
      check: false,
      textarea: "",
      isLoading: true,
      loadingBg: "rgba(255,255,255,1)",
      loadingTxt: "加载中",
      id: "",
      isChildComponent: false,
      //需要提交的数据
      fromData: {
        details: []
      },
      //不需要提交的数据
      noFromData: {}
    };
  },
  //设置校验规则
  vuerify: {
    "fromData.voucherDate": [
      "required" //必填项
      /* {
				test (val) {
					return /\d{4}-\d{1,2}-\d{1,2}/.test(val) && Date.parse(val)
				},
				message: '日期格式不正确 yyyy-mm-dd'
			}, */
    ]
  },
  computed: {
    errors() {
      return this.$vuerify.$errors;
    }
  },
  watch: {
    fromData: function(val, old) {
      console.log(val, old);
    }
  },
  created() {
    //请求初始数据
    this.$store.state.cache.TypeID=100 //选择销售订单数据
    this.getStartData();
  },
  methods: {
   
    ...mapActions("cache", ["clearCache"]),
    handleClick(tab, event) {},
    //关闭弹窗
    handleClose() {},
    //需要请求的初始数据
    async getStartData() {
      //客户
      if (!this.$store.state.cache.customerList) {
        let customerList = await this.$post(
          customerApi.list,
          this.$store.state.getAllPage
        );
        if (customerList.status) {
          console.log(customerList)
          customerList.data.list.forEach(item => {
            item.value = item.customerCode + "-" + item.customerName;
          });
          this.$store.state.cache.customerList = customerList.data.list;
        } else {
          this.$store.state.cache.customerList = null;
        }
      }
      //console.log(this.$store.state.cache.customerList,'==444==');
      //公司列表
      if (!this.$store.state.cache.companyList) {
        let companyList = await this.$post(
          company.list,
          this.$store.state.getAllPage
        );
        console.log(companyList, "==========");
        if (companyList.status) {
          companyList.data.list.forEach(item => {
            item.value = item.companyCode + "-" + item.companyName;
          });
          this.$store.state.cache.companyList = companyList.data.list;
          console.log(this.$store.state.cache.companyList, "====------====");
        } else {
          this.$store.state.cache.companyList = null;
        }
      }

      //客户采购订单编号
      if (!this.$store.state.cache.customerPurchCode) {
        let customerPurchCode = await this.$post(
          customerApi.list,
          this.$store.state.getAllPage
        );
        if (customerPurchCode.status) {
          customerPurchCode.data.list.forEach(item => {
            item.value = item.customerCode + "-" + item.customerName;
          });
          this.$store.state.cache.customerPurchCode =
            customerPurchCode.data.list;
        } else {
          this.$store.state.cache.customerPurchCode = null;
        }
      }

      this.isLoading = false;
    },

    //保存提交数据
    async subSave() {
      this.$refs.vList.onSubmitSaves()
      let vm = this;
      if (vm.check == true) {
        if (!this.fromData.saleId) {
          this.$message.error("请选择销售订单");
          return false;
        }
        if (!this.fromData.companyDesc) {
          this.$message.error("请选择公司");
          return false;
        }
        if (!this.fromData.customerDesc) {
          this.$message.error("请选择客户");
          return false;
        }
        if (!this.fromData.orderer) {
          this.$message.error("请选择联系人");
          return false;
        }
        if (!this.fromData.telephone) {
          this.$message.error("请选择联系电话");
          return false;
        }
        if (!this.fromData.address) {
          this.$message.error("请选择地址");
          return false;
        }
        if (!this.$store.state.cache.selectedMatterSaleSend.length) {
          this.$message.error("请选择物料明细");
          return false;
        }
        // let isTrue = true;
        // this.$store.state.cache.selectedMatterSaleSend.forEach(item => {
        //   if (!item.currentDeliveryNum) {
        //     vm.$message.error("请输入发货数量");
        //     isTrue = false;
        //     return false;
        //   } 
        // });
        // if (!isTrue) return false;
        this.fromData.details = [];
        this.fromData.details = this.$refs.vList.PurchOrderList;
        if(this.fromData.details.length == 0){ 
          this.$message.error('请勾选需要提交的数据明细！');
          return false;
        } 
        let isTrue = true;
        this.fromData.details.forEach(item => {
          if (!item.currentDeliveryNum) {
            vm.$message.error("请输入发货数量");
            isTrue = false;
            return false;
          } 
        });
        if (!isTrue) return false;
        this.fromData.maintainStatus = this.fromData.details[0].maintainStatus
        this.fromData.salesId = this.fromData.details[0].salesId
        console.log(this.fromData);
        this.fromData.voucherDate = this.$moment(
          this.fromData.voucherDate
        ).format("YYYY-MM-DD");
        this.fromData.postingDate = this.$moment(
          this.fromData.postingDate
        ).format("YYYY-MM-DD");
        this.isLoading = true;
        this.loadingBg = "rgba(255,255,255,0.5)";
        this.loadingTxt = "数据处理中...";
        let res = await this.$post(sendOrder.send, this.fromData);
        let json = JSON.stringify(this.fromData);
        console.log(json);
        this.isLoading = false;
        if (res.status) {
          console.log(res);
          this.$confirm(
            "物料凭证 " +
              res.data.materiales[0].verifyData.materailVoucherNo +
              " 已过账",
            "提示",
            {
              confirmButtonText: "继续",
              cancelButtonText: "退出",
              type: "success"
            }
          )
            .then(() => {
              this.fromData = {};
              this.noFromData = {};
              this.textarea = ''
              vm.$store.state.cache.selectedMatterSaleSend = [];
              vm.$router.push({ name: "business-sale-orderSend" });
              //清除部分缓存数据
              vm.clearCache();
            })
            .catch(() => {
              vm.$router.push({ name: "home" });
			        vm.fromData.saleId = ''
              vm.fromData.companyDesc = ''
              vm.fromData.customerDesc = ''
              vm.fromData.refRoucherStatus = ''
              vm.fromData.voucherHeaderTxt = ''
              vm.fromData.orderer = ''
              vm.fromData.telephone = ''
              vm.fromData.address = ''
			        vm.$store.state.cache.selectedMatterSaleSend = [];
              //清除部分缓存数据
              vm.clearCache();
            });
        } else {
          this.$message.error(res.errorMsg);
        }
      } else {
        this.$message.error("请先检查数据，再进行提交");
      }
    },

    //检查数据
    async subCheck() {
      this.$refs.vList.onSubmitSaves()
      let vm = this;
      if (!this.fromData.saleId) {
        this.$message.error("请选择销售订单");
        return false;
      }
      if (!this.fromData.companyDesc) {
        this.$message.error("请选择公司");
        return false;
      }
      if (!this.fromData.customerDesc) {
        this.$message.error("请选择客户");
        return false;
      }
      if (!this.fromData.orderer) {
        this.$message.error("请选择联系人");
        return false;
      }
      if (!this.fromData.telephone) {
        this.$message.error("请选择联系电话");
        return false;
      }
      if (!this.fromData.address) {
        this.$message.error("请选择地址");
        return false;
      }
      if (!this.$store.state.cache.selectedMatterSaleSend.length) {
        this.$message.error("请选择物料明细");
        return false;
      }
      this.fromData.details = [];
      // let isTrue = true;
      // this.$store.state.cache.selectedMatterSaleSend.forEach(item => {
      //   if (!item.currentDeliveryNum) {
      //     vm.$message.error("请输入发货数量");
      //     isTrue = false;
      //     return false;
      //   }
      // });
      // if (!isTrue) return false;
      this.fromData.details = this.$refs.vList.PurchOrderList;
      if(this.fromData.details.length == 0){ 
        this.$message.error('请勾选需要检查的数据明细！');
        return false;
      }
      let isTrue = true;
        this.fromData.details.forEach(item => {
          if (!item.currentDeliveryNum) {
            vm.$message.error("请输入发货数量");
            isTrue = false;
            return false;
          } 
        });
        if (!isTrue) return false;
      console.log(this.fromData.details);
      this.isLoading = true;
      this.loadingBg = "rgba(255,255,255,0.5)";
      this.loadingTxt = "数据处理中...";
      let res = await this.$post(sendOrder.check, this.fromData);
      let json = JSON.stringify(this.fromData);
      console.log(json);
      console.log(res)
      this.isLoading = false;
      if (res.status) {
        // console.log(res.data.verifyResult)

        let verifyDesc = res.data.verifyResult;
        let errorStr = "";
        if(verifyDesc == "E"){   
          res.data.materiales.forEach((item)=>{
            if(item.verifyResult == "E"){
              errorStr = errorStr + item.verifyDesc.join(",");
            }
          });
        }else{
          errorStr = "数据检查无误，请继续操作！"
        }
        this.$confirm(errorStr, "提示", {
          confirmButtonText: "继续",
          cancelButtonText: "退出",
          type: "success"
        })
          .then(() => {
            vm.check = true;
            //凭证和过账默认今天 
            let nowData = new Date();
            vm.$router.push({ name: "business-sale-orderSend" });
            //清除部分缓存数据
            vm.clearCache();
          })
          .catch(() => {
            vm.fromData.saleId = ''
            vm.fromData.companyDesc = ''
            vm.fromData.customerDesc = ''
            vm.fromData.refRoucherStatus = ''
            vm.fromData.voucherHeaderTxt = ''
            vm.fromData.orderer = ''
            vm.fromData.telephone = ''
            vm.fromData.address = ''
		      	vm.$store.state.cache.selectedMatterSaleSend = [];
            vm.$router.push({ name: "business-sale-orderSend" });
            //清除部分缓存数据
            vm.clearCache();
          });
      } else {
        this.$message.error(res.errorMsg);
      }
    }
  }
};
</script>

<style lang="stylus" scoped></style>
